import request from '@/service/request';

//获取热点事件
export const getHotspotList = () => request({
  url:'/museum/api/wfEventSpace/open/getHotspotList',
  method: 'get',
})
//获取全部事件
export const getAllEventList = (params) => request({
  url:'/museum/api/wfEventSpace/open/getAllEventList',
  method: 'get',
  params:params
})
//获取事件空间首页seo配置
export const getSeoConfig = (params) => request({
  url:'/museum/api/wfEventSpace/open/getSeoConfig',
  method: 'get',
  params:params
})


